import {Heading} from '@primer/react'
import type {FC, ReactNode} from 'react'

interface PanelHeaderProps {
  title: string
  subtitle?: string
  as?: 'h2' | 'h3'
  trailing?: ReactNode
}

export const PanelHeader: FC<PanelHeaderProps> = ({title, subtitle, as = 'h2', trailing}) => {
  return (
    <>
      <div className="d-flex">
        <Heading as={as} className={`${as === 'h2' ? 'f2 text-normal' : 'f3 text-normal'}`}>
          {title}
        </Heading>
        {trailing}
      </div>
      {subtitle ? <span className="fgColor-muted">{subtitle}</span> : null}
    </>
  )
}

try{ PanelHeader.displayName ||= 'PanelHeader' } catch {}